"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isValidPageName = exports.isPredefinedPage = exports.getInputValidations = exports.MAX_PAGE_NAME_LENGTH = exports.MAX_PAGE_COUNT = exports.DEFAULT_PAGE_NAME = void 0;
// disallow the following characters: \ @ * + / _
// eslint-disable-next-line prefer-regex-literals
var regexPageName = new RegExp("^[^\\\\%@*+/_]*$");
var DEFAULT_PAGE_NAME = exports.DEFAULT_PAGE_NAME = 'home';
var MAX_PAGE_NAME_LENGTH = exports.MAX_PAGE_NAME_LENGTH = 128;
var MAX_PAGE_COUNT = exports.MAX_PAGE_COUNT = 50;
var isDefaultPage = function isDefaultPage(name, _ref) {
  var caseSensitive = _ref.caseSensitive;
  if (caseSensitive) {
    return name && DEFAULT_PAGE_NAME ? name.toLowerCase() === DEFAULT_PAGE_NAME : false;
  }
  return name === DEFAULT_PAGE_NAME;
};
var pageAlreadyExists = function pageAlreadyExists() {
  var pages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var pageName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return pages.some(function (page) {
    return pageName === page.name;
  }) || isDefaultPage(pageName, {
    caseSensitive: true
  });
};
var noDisallowedChars = function noDisallowedChars(pageName) {
  return regexPageName.test(pageName);
};
var lengthInRange = function lengthInRange(pageName) {
  return pageName.length >= 1 && pageName.length <= MAX_PAGE_NAME_LENGTH;
};
var isHiddenPage = function isHiddenPage(pageName) {
  return pageName.startsWith('.');
};
var isPredefinedPage = exports.isPredefinedPage = function isPredefinedPage(pageName) {
  return isDefaultPage(pageName, {
    caseSensitive: false
  }) || isHiddenPage(pageName);
};
var isValidPageName = exports.isValidPageName = function isValidPageName(pages, pageName) {
  return pageName && noDisallowedChars(pageName) && lengthInRange(pageName) && !isHiddenPage(pageName) && !pageAlreadyExists(pages, pageName);
};
var getInputValidations = exports.getInputValidations = function getInputValidations(pages) {
  return {
    nonExistentName: {
      validate: function validate(_ref2) {
        var value = _ref2.value;
        return (
          // we don't want to show this message for default page name
          isDefaultPage(value.trim(), {
            caseSensitive: true
          }) || !pageAlreadyExists(pages, value.trim())
        );
      },
      message: 'Page name is already used.'
    },
    noInvalidCharacters: {
      validate: function validate(_ref3) {
        var value = _ref3.value;
        return noDisallowedChars(value);
      },
      message: 'Page name cannot contain these characters: % @ * + / _ \\'
    },
    notHomePage: {
      validate: function validate(_ref4) {
        var value = _ref4.value;
        return !isDefaultPage(value.trim(), {
          caseSensitive: true
        });
      },
      message: "Page name cannot be the reserved name \"".concat(DEFAULT_PAGE_NAME, "\".")
    },
    noDotStart: {
      validate: function validate(_ref5) {
        var value = _ref5.value;
        return !isHiddenPage(value.trim());
      },
      message: 'Page name cannot start with "."'
    }
  };
};
//# sourceMappingURL=validations.js.map